import Environment, { Tracker } from './base';

const environments: Environment = {
  isDevelopment: false,
  serviceHostName: 'https://api-oa.pantavanij.com',
  clientID: 'emarketplace',
  keycloakHostName: 'https://service.pantavanij.com/keycloak',
  productHostName: 'https://service.pantavanij.com/product',
  keycloakRealm: 'ptvn',
  eMarketplaceFrontend: 'https://emarketplace.pantavanij.com',
  erfxFrontend: 'https://erfxonline.pantavanij.com',
  eventHostName: 'https://event-oa.pantavanij.com',
  trackerId: { ga: 'UA-147300659-6', msClarity: '7o3xd824e7', ga4: 'G-83HG7JP14Y' },
  supplierConnectFrontend: 'https://supplier.pantavanij.com',
  adminFrontend: 'https://admin.pantavanij.com',
  adminClientID: 'eauction-admin',
  oneTrustDataDomainScript: '0806e312-4b19-4d4a-91e5-79a07d2bd906',
  epFrontend: 'https://ep.pantavanij.com',
  oneplanetFrontend: 'https://oneplanetapp.com',
  cookieAgent: 'https://cookie-qa.pantavanij.com',
  cookieKey: 'iKsJRwNIXYVAB0TIvVgi',
  epLogin: 'http://ep.pantavanij.com/Firstpage.action',
  opLogin: '',
  oneplanetLogin: 'http://oneplanets.com/signin',
  supplierConnectLogin: 'https://emarketplace.pantavanij.com/login?idp=sww',
  ptvnImagesLink: 'https://media.pantavanij.com/assets/image',
  jiraIssueCollector:
    'https://ptvn.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/1jmxwi/b/8/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=532a6045',
  hotjar: {
    siteId: 3186255,
    hotjarVersion: 6,
  },
  storeManagement: 'https://supplier.pantavanij.com/product/list',
  commodityBypassToken: 'bKnxZ7KxyT36LMQr',
};

export default environments;
